import React from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  Avatar,
  Card,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import { RootState } from "src/store";
import {
  getUserDisplayName,
  getUserAvatar,
  getUserCompanyName,
  getUserCompanyWebsite,
  getUserEmail,
} from "src/features/authSlice";

const ProfilePage = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  if (!user) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography variant="h6">No user data available.</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Card sx={{ maxWidth: 400, padding: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar
            src={getUserAvatar(user)}
            sx={{ width: 100, height: 100, marginBottom: 2 }}
          />
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            {getUserDisplayName(user)}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            {getUserEmail(user)}
          </Typography>
        </Box>
        <CardContent>
          {user?.accountType === "company" && (
            <>
              <Typography variant="body1">
                <strong>Company:</strong> {getUserCompanyName(user)}
              </Typography>
              <Typography variant="body1">
                <strong>Website:</strong> {getUserCompanyWebsite(user)}
              </Typography>
            </>
          )}
        </CardContent>
        <CardActions sx={{ justifyContent: "center" }}>
          <Button variant="contained" color="primary">
            Edit Profile
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};

export default ProfilePage;
